module.exports = __webpack_public_path__ + "static/environmental-disturbance_ceramic-glaze-mixed-media-12dimx4h-in-c1ad5ca0820917e20cedaf4da5f220af.jpg";